const { customerList } = require("constants/customer");

const initialState = {
  customerList: {},
};

const customer = (state = initialState, action) => {
  switch (action.type) {
    case customerList:
      return { ...state, customerList: action.payload };

    default:
      return state;
  }
};
export default customer;
